<template>
<v-select :options="eventTypeList" :value="value" @input="update" placeholder="Select Bhandara/Satsang" :onChange="onChange"></v-select>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'EventTypeSelect',
  props: {
    value: [String, Object, Array],
    change: {
      type: Function
    }
  },
  computed: {
    eventTypeList() {
      return Vue._.map(this.$store.state.eventTypes.all, (eventType) => {
        return {
          label: eventType.name,
          value: eventType.id
        }
      })
    }
  },
  methods: {
    update(val) {
      this.$emit('input', val)
    },
    onChange(val) {
      if (this.change) {
        this.change(val)
      }
    }
  },
  created() {
    if (this.$store.state.eventTypes.all.length == 0) {
      this.$store.dispatch('eventTypes/getEventTypes')
    }
  },
}
</script>
